import { useCallback } from 'react';
import { uniqueId } from 'js/utils/methods.util';

import * as Types from './types';
import { TServerSendRequest } from '../../types';
import { useGenericSend } from '../useGenericSend';
import { IGNORE_LIMITS_NOTIFICATION } from '../../constants';

export const useGetDepositLimits = () => {
    const send = useGenericSend();

    return useCallback(async (): Promise<Types.IGetDepositLimitsResponseData> => {
        const { data } = await send<TServerSendRequest, Types.IGetDepositLimitsResponseData>({
            ID: 89901,
            responses: [89905, 89900],
            description: 'Get deposit limits',
            errorLevel: 1,
            correlationId: uniqueId(`${IGNORE_LIMITS_NOTIFICATION}-`)
        });

        return data;
    }, [
        send
    ]);
};
